import { createEntity } from 'lib/resource';
import { runOperation } from 'app/operations';
import store from 'app/store';
import Schema from './collection-schema';
import Entity from './entity-schema';

export default createEntity(Schema, Entity, {
  getState() {
    return store.get().getState();
  },

  runOperation,
});
